import { ColDef, ICellRendererParams, ValueFormatterParams } from "ag-grid-community";
import { Contact } from "@models/common/contact";
import { PhonePipe } from "@shared/pipes/phonePipe";

export const getContactsOverlayNoRowsTemplate = () => 'There are no contacts available for this individual. Click to add a new contact';

export function getContactsColDefs(selectable: boolean, actionColumn: ColDef | null = null): ColDef[] {
  const baseColDefs: ColDef[] = [
    {
      headerName: 'Email',
      field: 'email',
      minWidth: 200,
      flex: 1,
      checkboxSelection: selectable,
      cellRenderer: (individual: ICellRendererParams<Contact>) => {
        const fieldsAndPrefixes = [
          { field: 'email', prefix: '' },
          { field: 'carbonCopy', prefix: 'cc: ' },
          { field: 'blindCarbonCopy', prefix: 'bcc: ' },
        ];

        return fieldsAndPrefixes
          .map(({ field, prefix }) => {
            return `
              <div class="line-height-16">
                  <span class="prefix hide-empty color-gray-600">${ prefix }</span>
                  <span class="value">${ individual.data?.[field] || '' }</span>
              </div>
            `;
          })
          .join('');
      }
    },
    {
      headerName: 'Phone Number',
      field: 'phone',
      valueFormatter:(params: ValueFormatterParams<Contact>) => PhonePipe.formatValue(params.value),
      minWidth: 165,
      width: 165,
    },
    {
      headerName: 'Type of Contact',
      field: 'nickname',
      minWidth: 165,
      width: 165,
    }
  ];

  if (actionColumn) {
    baseColDefs.push(actionColumn);
  }

  return baseColDefs.map((colDef) => ({
    ...colDef,
    editable: false,
    sortable: false,
    suppressHeaderMenuButton: true,
  }));
}
